import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-partner-pending',
    templateUrl: './partner-pending.component.html',
    standalone: false
})
export class PartnerPendingComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
